import './index.less';

import { FC, lazy, Suspense, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { PageLevel } from '@/components/PageContainer';
import PageHeader from '@/components/PageContainer/PageHeader';
import { useI18nContext } from '@/i18n/I18n';
const LazyEntry = lazy(() => import('./lazyEntry'));

const AccountActivity: FC = () => {
  const [$t] = useI18nContext();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="account-activity">
        <PageHeader
          pageLevel={PageLevel.sub}
          breadItems={[
            {
              key: 'accountBaseInfo',
              label: () => (
                <Link to="/app/user/account-info">{$t('accountBaseInfo')}</Link>
              ),
            },
            {
              key: 'Account Activities',
              title: $t('Account Activities'),
            },
          ]}
        />
        <Suspense fallback="">
          <LazyEntry />
        </Suspense>
      </div>
    </>
  );
};
export default AccountActivity;
